import React, { useEffect, useState, Fragment } from "react";
import { connect } from "react-redux";
import axios from "axios";
import Layout from "../layout/Layout";
import Spinner from "../layout/Spinner";
import JobItem from "./JobItem";
import { api } from "../utils/Api";
import PlantPicker2 from "../plant/PlantPicker2";
import Modal from "react-bootstrap/Modal";
import { toThousands } from "../utils/Convert";
import SubplantPicker2 from "../plant/SubplantPicker2";
import JobsSellerClassification from "./JobSellerClassification";
import {
	Button,
	Row,
	Col,
	Typography,
	DatePicker,
	Modal as ModalAntd,
	Statistic,
} from "antd";
import dayjs from "dayjs";
import { CameraOutlined, RetweetOutlined } from "@ant-design/icons";
import ApprovedPriceByStatus from "./ApprovedPriceByStatus";
import html2canvas from "html2canvas";
import DownloadDailyByJobStatus from "./DownloadDailyByJobStatus";
import { getAggregateCogsCost } from "../utils/CogCost";

const { Text } = Typography;

const DAppointment = ({ history }) => {
	const [date, setDate] = useState(dayjs());

	const [update, setUpdate] = useState(false);
	const [refresh, setRefresh] = useState(false);
	const [updateAll, setUpdateAll] = useState(false);
	const [jobs, SetJobs] = useState([]);
	const [sumLoadYd3, setSumLoadY3] = useState(0);
	const [sumTarget, setSumTarget] = useState(0);
	const [sumBalance, setSumBalance] = useState(0);
	const [loading, setLoading] = useState(true);
	const [jobHold, setJobHold] = useState(
		localStorage.getItem("jobHold") === "true" ? true : false,
	);
	const [waitingInspection, setWaitingInspection] = useState(false);
	const [plant, setPlant] = useState(
		localStorage.getItem("plant") || "61985b6a86825f39cc4aba38",
	);
	const [plantName, setPlantName] = useState("Mission");
	const [showModal, setShowModal] = useState(false);
	const [showModalApprovedPrice, setShowModalApprovedPrice] = useState(false);
	const [showModalDownloadDaily, setShowModalDownloadDaily] = useState(false);
	const [subplant, setSubplant] = useState(
		localStorage.getItem("subplant") || "All",
	);
	const [scheduledTargetYD3, setScheduledTargetYD3] = useState(0);
	const [pouringTargetYD3, setPouringTargetYD3] = useState(0);
	const [pouringLoadYD3, setPouringLoadYD3] = useState(0);
	const [pouredLoadYD3, setPouredLoadYD3] = useState(0);
	const [readyTargetYD3, setReadyTargetYD3] = useState(0);
	const isPriorityActive =
		localStorage.getItem("email") === "vm@57concrete.com" ||
		localStorage.getItem("email") === "dm@57concrete.com" ||
		localStorage.getItem("email") === "rs@57concrete.com" ||
		localStorage.getItem("email") === "jh@57concrete.com" ||
		localStorage.getItem("email") === "rl@57concrete.com" ||
		localStorage.getItem("email") === "ec@57concrete.com" ||
		localStorage.getItem("email") === "pc@57concrete.com" ||
		localStorage.getItem("email") === "jc@57concrete.com" ||
		localStorage.getItem("email") === "gg@57xgroup.com" ||
		localStorage.getItem("email") === "bp@57concrete.com" ||
		localStorage.getItem("email") === "bpa@57concrete.com" ||
		localStorage.getItem("email") === "jp@57concrete.com" ||
		localStorage.getItem("email") === "dmad@57concrete.com" ||
		localStorage.getItem("email") === "eliud@gmail.com";
	const hideRestrictedFields =
		localStorage.getItem("email") === "bm@57concrete.com" ||
		localStorage.getItem("email") === "mgr@57concrete.com";
	const [avgGross, setAvgGross] = useState(0);

	useEffect(() => {
		setLoading(true);
		setSumLoadY3(0);
		const currentDate = `${date.year()}-${date.month() + 1}-${date.date()}`;
		getJobs(currentDate, plant, subplant);
		getGlobalYards(currentDate);
	}, [date, waitingInspection, updateAll, refresh]);

	useEffect(() => {}, [update]);

	const loadUpdated = (newLoad) => {
		let newSum = sumLoadYd3 + newLoad;
		const result = Math.round(newSum * 100) / 100;
		setSumLoadY3(result);
		const globalYards =
			parseFloat(localStorage.getItem("globalYards")) + newLoad;
		localStorage.setItem("globalYards", globalYards);
		setUpdate(!update);
	};

	const getJobs = async (today, plant, subplant) => {
		let url = "";
		if (subplant === "All") {
			url = api + `/jobdateplant/57Concrete?date=${today}&plant=${plant}`;
		} else {
			url =
				api +
				`/jobdateplantsub/57Concrete?date=${today}&plant=${plant}&subplant=${subplant}`;
		}
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			setLoading(true);
			const { data } = await axios.get(url);
			const { data: data2 } = await axios.get(
				api + `/avggross/get?dateString=${today}&plant=${plant}`,
			);
			assignData(data, data2); // Fill list with data
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getGlobalYards = async (today) => {
		const url = api + `/job/get/global/yards?date=${today}`;

		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			setLoading(true);
			const { data } = await axios.get(url);
			if (data.success) {
				const globalYards = data.payload.reduce(
					(acc, job) => acc + job.loadYD3,
					0,
				);
				localStorage.setItem("globalYards", globalYards);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	// change plant
	const onChangePlant = (selectedPlant) => {
		setPlant(selectedPlant.value);
		setPlantName(selectedPlant.label);
		const fecha = `${date.year()}-${date.month() + 1}-${date.date()}`;
		getJobs(fecha, selectedPlant.value, subplant);
		getGlobalYards(fecha);
	};

	// change plant
	const onChangeSubplant = (selectedSubplant) => {
		setSubplant(selectedSubplant);
		const fecha = `${date.year()}-${date.month() + 1}-${date.date()}`;
		getJobs(fecha, plant, selectedSubplant);
		getGlobalYards(fecha);
	};

	// Assign API response to local array "jobs" & calculate totals
	const assignData = (data, data2) => {
		if (localStorage.getItem("role") === "Batch") {
			data = data.filter(
				(job) => job.subplant === localStorage.getItem("subplant"),
			);
		}

		if (
			localStorage.getItem("role") === "Seller" &&
			localStorage.getItem("email") !== "dm@57concrete.com" &&
			localStorage.getItem("email") !== "bm@57concrete.com" &&
			localStorage.getItem("email") !== "jp@57concrete.com" &&
			localStorage.getItem("email") !== "scale@filegonia.com"
		) {
			data = data.filter((job) => job.franchise !== "Castle");
		}

		// suma de importe ($)
		const validJobs = data.filter(
			(d) =>
				d.jobStatus === "ok" ||
				d.jobStatus === "Confirm" ||
				d.jobStatus === "Operations done (AR)" ||
				d.jobStatus === "Scheduled" ||
				d.jobStatus === "Date moved" ||
				d.jobStatus === "Active" ||
				d.jobStatus === "Ready to Load" ||
				d.jobStatus === "Waiting Inspection",
		);
		const result = validJobs.reduce((acc, elJob) => acc + elJob.loadYD3, 0);
		const totalLoad = Math.round(result * 100) / 100;
		localStorage.setItem("loadSum", totalLoad);

		// suma de target
		var suma = 0;
		var sumBalance = 0;
		var sumWait = 0;
		data.forEach((element) => {
			let operandos =
				typeof element.targetYD3 === "string"
					? element.targetYD3.split("+")
					: element.targetYD3;
			if (
				element.jobStatus !== "Quote" &&
				element.jobStatus !== "Waiting Inspection" &&
				element.jobStatus !== "Wait Inspection" &&
				element.jobStatus !== "Company cancellation" &&
				element.jobStatus !== "Customer cancellation" &&
				element.jobStatus !== "Trouble" &&
				element.jobStatus !== "New Order"
			) {
				suma =
					suma +
					(typeof element.targetYD3 === "string"
						? parseFloat(operandos[0])
						: operandos);
			}

			if (
				element.jobStatus === "Waiting Inspection" ||
				element.jobStatus === "Wait Inspection"
			) {
				sumWait =
					sumWait +
					(typeof element.targetYD3 === "string"
						? parseFloat(operandos[0])
						: operandos);
			}

			var balance = element.balance ? element.balance : 0;
			sumBalance = sumBalance + parseFloat(balance);
		});
		localStorage.setItem("targetSum", suma);
		localStorage.setItem("sumBalance", sumBalance);
		localStorage.setItem("waitingInspection", sumWait);

		const today = dayjs().startOf("day");
		const selectedDate = date.startOf("day");

		const isToday = selectedDate.isSame(today);
		const isFuture = selectedDate.isAfter(today);

		if (!isToday && !isFuture) {
			setAvgGross(data2.success ? data2.payload.avgGross : 0);
		} else {
			let grossJobs = data.filter(
				(job) =>
					isToday
						? ["Active", "ok", "Scheduled", "Operations done (AR)"].includes(
								job.jobStatus,
							)
						: ["Scheduled", "Ready to Load", "Confirm"].includes(job.jobStatus),
				// : isFuture
				// 	? ["Scheduled", "Ready to Load", "Confirm"].includes(
				// 			job.jobStatus,
				// 		)
				// 	: ["Operations done (AR)", "ok"].includes(job.jobStatus),
				// 		&&
				// (job.paymentType === "Credit"
				// 	? job.hold || !job.creditApproved
				// 	: job.hold) === false &&
				// job.approved === true,
			);

			let sumGross = 0;
			let sumLoadYD3 = 0;

			grossJobs.map((job) => {
				const cogs = getAggregateCogsCost(job.aggregate);
				const unitPrice = job.unitPrice;

				const gross = unitPrice - cogs;

				const mulGross = gross * (isFuture ? job.targetYD3 : job.loadYD3);

				sumGross += mulGross;
				sumLoadYD3 += (isFuture ? job.targetYD3 : job.loadYD3) || 0;
			});

			const avgGross = sumGross / sumLoadYD3;
			setAvgGross(sumLoadYD3 === 0 ? 0 : avgGross.toFixed(2));
		}

		// organize total yards and load
		assignDataTarget(data);

		SetJobs(data);
		setSumLoadY3(totalLoad);
		// setSumTarget(suma);
		setSumBalance(sumBalance);
		setLoading(false);
	};

	const assignDataTarget = (data) => {
		const scheduledData = data.filter((job) => job.jobStatus === "Scheduled");
		const scheduledYards = scheduledData.reduce(
			(accum, current) => accum + current.targetYD3,
			0,
		);
		setScheduledTargetYD3(scheduledYards);

		const pouringData = data.filter((job) => job.jobStatus === "Active");
		const pouringYards = pouringData.reduce(
			(accum, current) => accum + current.targetYD3,
			0,
		);
		const pouringLoads = pouringData.reduce(
			(accum, current) => accum + current.loadYD3,
			0,
		);
		setPouringTargetYD3(pouringYards);
		setPouringLoadYD3(pouringLoads);

		const pouredData = data.filter((job) => job.jobStatus === "ok");
		const pouredLoads = pouredData.reduce(
			(accum, current) => accum + current.loadYD3,
			0,
		);
		setPouredLoadYD3(pouredLoads);

		const readyData = data.filter((job) => job.jobStatus === "Ready to Load");
		const readyYards = readyData.reduce(
			(accum, current) => accum + current.targetYD3,
			0,
		);
		setReadyTargetYD3(readyYards);
	};

	const waitingInspectionCallback = () => {
		setWaitingInspection(!waitingInspection);
	};

	// call component for table row drawing status !== done
	const losJobs = () => {
		if (jobs.length > 0) {
			return jobs
				.filter(
					(jb) =>
						jb.jobStatus !== "Operations done (AR)" &&
						jb.jobStatus !== "ok" &&
						jb.jobStatus !== "Active" &&
						jb.jobStatus !== "Confirm" &&
						jb.jobStatus !== "Ready to Load" &&
						jb.jobStatus !== "Waiting Inspection" &&
						jb.jobStatus !== "Scheduled" &&
						jb.jobStatus !== "New Order",
				)
				.map((currentJob, i) => {
					return (
						<JobItem
							pcb={loadUpdated}
							job={currentJob}
							key={i}
							action={setUpdateAll}
							wic={waitingInspectionCallback}
							hideRestrictedFields={hideRestrictedFields}
						/>
					);
				});
		} else {
			return (
				<tr>
					<td colSpan="35" style={{ textAlign: "center" }}>
						No jobs for selected date
					</td>
				</tr>
			);
		}
	};

	// call component for table row drawing status
	const jobsForStatus = (status) => {
		if (jobs.length > 0) {
			return jobs
				.filter((jb) => jb.jobStatus === status)
				.map((currentJob, i) => {
					return (
						<JobItem
							pcb={loadUpdated}
							job={currentJob}
							key={i}
							action={setUpdateAll}
							wic={waitingInspectionCallback}
							hideRestrictedFields={hideRestrictedFields}
						/>
					);
				});
		}
	};

	// call component for table row drawing status Scheduled
	const jobsForStatus2 = (status) => {
		if (jobs.filter((jb) => jb.jobStatus === status).length > 0) {
			return jobs
				.filter((jb) => jb.jobStatus === status)
				.map((currentJob, i) => {
					return (
						<JobItem
							pcb={loadUpdated}
							job={currentJob}
							key={i}
							action={setUpdateAll}
							wic={waitingInspectionCallback}
							hideRestrictedFields={hideRestrictedFields}
						/>
					);
				});
		} else {
			return (
				<tr>
					<td colSpan="35" style={{ textAlign: "center" }}>
						No jobs for selected date
					</td>
				</tr>
			);
		}
	};

	//48143

	const renderLoading = () => {
		return <Spinner />;
	};

	const handleShowModal = () => {
		setShowModal(!showModal);
	};

	const handleShowModalApprovedPrice = () => {
		setShowModalApprovedPrice(!showModalApprovedPrice);
	};

	const handleShowModalDownloadDaily = () => {
		setShowModalDownloadDaily(!showModalDownloadDaily);
	};

	const takeScreenshot = async () => {
		const canvas = await html2canvas(document.body, {
			width: document.body.scrollWidth,
			height: document.body.scrollHeight,
			windowWidth: document.body.scrollWidth,
			windowHeight: document.body.scrollHeight,
		});

		const image = canvas.toDataURL("image/png");

		const link = document.createElement("a");
		link.download = "screenshot.png";
		link.href = image;
		link.click();
	};

	const renderJobs = () => (
		<Fragment>
			<h3>
				{`Total YD: ${toThousands(localStorage.getItem("loadSum"))}, 
                    Total Target: ${toThousands(
											parseFloat(localStorage.getItem("targetSum")).toFixed(2),
										)}, 
                    Total Balance: ${toThousands(
											parseFloat(localStorage.getItem("sumBalance")).toFixed(2),
										)},
                    Waiting Inspection: ${toThousands(
											parseFloat(
												localStorage.getItem("waitingInspection"),
											).toFixed(2),
										)}, Global Total YD: ${toThousands(
											parseFloat(localStorage.getItem("globalYards")).toFixed(
												2,
											),
										)}`}
			</h3>
			<Row gutter={[16, 8]} justify={"start"}>
				<Col span={24} xl={10}>
					<Row gutter={[16, 8]} align={"bottom"}>
						<Col span={24} lg={6}>
							<Row>
								<Col span={24}>
									<Text>Date</Text>
								</Col>
								<Col span={24}>
									<DatePicker
										value={date}
										onChange={(date) => setDate(date)}
										format={"MM/DD/YYYY"}
										size="large"
										disabled={loading}
										allowClear={false}
										style={{ width: "100%" }}
									/>
								</Col>
							</Row>
						</Col>
						{localStorage.getItem("role") !== "Batch" && (
							<Col span={24} lg={6}>
								<Row>
									<Col span={24}>
										<Text>Plant</Text>
									</Col>
									<Col span={24}>
										<PlantPicker2 onChange={onChangePlant} value={plant} />
									</Col>
								</Row>
							</Col>
						)}
						{localStorage.getItem("role") !== "Batch" && (
							<Col span={24} lg={6}>
								<Row>
									<Col span={24}>
										<Text>Subplant</Text>
									</Col>
									<Col span={24}>
										<SubplantPicker2
											onChange={onChangeSubplant}
											value={subplant}
											isComplete={true}
											plant={plant}
											setSubplant={(value) => setSubplant(value)}
										/>
									</Col>
								</Row>
							</Col>
						)}
						<Col>
							<Button
								type="primary"
								size="large"
								onClick={() => setRefresh((prev) => !prev)}
								icon={<RetweetOutlined />}
							/>
						</Col>
						<Col span={24}>
							<Row gutter={[16, 8]}>
								<Col>
									<Button
										type="primary"
										size="large"
										onClick={() => history.push("/heatmap")}
									>
										Driver's Heatmap
									</Button>
								</Col>
								<Col>
									<Button type="primary" size="large" onClick={handleShowModal}>
										Yards Per Seller
									</Button>
								</Col>
								{(localStorage.getItem("email") === "eliud@gmail.com" ||
									localStorage.getItem("email") === "pc@57concrete.com" ||
									localStorage.getItem("email") === "jc@57concrete.com" ||
									localStorage.getItem("email") === "gg@57xgroup.com" ||
									localStorage.getItem("email") === "ec@57concrete.com") && (
									<Col>
										<Button
											type="primary"
											size="large"
											onClick={handleShowModalApprovedPrice}
										>
											Approved Price by Status
										</Button>
									</Col>
								)}
								{(localStorage.getItem("email") === "eliud@gmail.com" ||
									localStorage.getItem("email") === "jp@57concrete.com" ||
									localStorage.getItem("email") === "fr@57concrete.com" ||
									localStorage.getItem("email") === "rs@57concrete.com" ||
									localStorage.getItem("email") === "ec@57concrete.com") && (
									<Col>
										<Button
											type="primary"
											size="large"
											onClick={handleShowModalDownloadDaily}
										>
											Download Daily
										</Button>
									</Col>
								)}
								{(localStorage.getItem("email") === "eliud@gmail.com" ||
									localStorage.getItem("email") === "ec@57concrete.com") && (
									<Col>
										<Button
											onClick={takeScreenshot}
											icon={<CameraOutlined />}
											size="large"
										>
											Take Screenshot
										</Button>
									</Col>
								)}
							</Row>
						</Col>
					</Row>
				</Col>
				<Col span={24} lg={4} style={{ textAlign: "center" }}>
					<div
						style={{
							backgroundColor: "#0859d2",
							padding: "10px",
							borderRadius: "5px",
						}}
					>
						<Statistic
							title={<span style={{ color: "white" }}>AVG. Gross $/Cy</span>}
							value={avgGross}
							prefix={"$"}
							precision={2}
							valueStyle={{ color: "white" }}
						/>
					</div>
				</Col>
			</Row>
			<RenderScheduledJobs />
			<RenderPouringJobs />
			<RenderPouredJobs />
			<RenderRegularJobs />
		</Fragment>
	);

	const RenderScheduledJobs = () => {
		return (
			<div style={{ fontSize: "13px" }}>
				<h3>Scheduled Jobs</h3>
				<h5>Total TargetYD3: {scheduledTargetYD3}</h5>
				<div className="table-responsive overflow-auto">
					<table className="table">
						<thead>
							<tr>
								<th>Confirm</th>
								<th>JobID</th>
								<th style={{ width: "10%" }}>Customer</th>
								<th>Customer PO#</th>
								<th>Seller</th>
								{!hideRestrictedFields && (
									<>
										<th>Foreman</th>
										<th>Foreman Phone</th>
										<th>Relocated</th>
										<th>Subplant</th>
									</>
								)}
								<th>Time</th>
								<th>Job Address</th>
								<th>Load YD3</th>
								<th>Target YD3</th>
								<th>Rate (CY/HR)</th>
								{!hideRestrictedFields && (
									<>
										<th>On Time</th>
										<th>Dest. Time</th>
										<th>Dest. Milles</th>
									</>
								)}
								<th style={{ width: "4%" }}>Mix Design</th>
								<th>Slump</th>
								<th>Fiber YD3</th>
								<th>COGS</th>
								<th>Sold Price</th>
								<th>Gross</th>
								<th>Approved Price</th>
								<th>QB Price</th>
								{!hideRestrictedFields && (
									<>
										<th>Factored Invoice</th>
										<th>Minimum Price</th>
										<th>Maximum Price</th>
									</>
								)}
								<th>Pour/Type</th>
								<th>Status</th>
								<th>Scheduled Date</th>
								{jobHold && <th>Hold</th>}
								<th>Check In</th>
								<th>Ice Surcharge</th>
								<th>Light Surcharge</th>
								<th>Pour</th>
								<th>QA/QC</th>
								<th>Etickets</th>
								{/* <th>Project</th> */}
								{isPriorityActive && <th>Priority</th>}
								<th style={{ width: "6%" }}>Comments</th>
								<th>Franchise</th>
								<th>Edit</th>
							</tr>
						</thead>
						<tbody>{jobsForStatus2("Scheduled")}</tbody>
					</table>
				</div>
			</div>
		);
	};
	const RenderPouringJobs = () => {
		return (
			<div style={{ fontSize: "13px" }}>
				<h3>Pouring Jobs</h3>
				<h5>Total TargetYD3: {pouringTargetYD3}</h5>
				<h5>Total LoadYD3: {pouringLoadYD3}</h5>
				<div className="table-responsive overflow-auto">
					<table className="table">
						<thead>
							<tr>
								<th>Confirm</th>
								<th>JobID</th>
								<th style={{ width: "10%" }}>Customer</th>
								<th>Customer PO#</th>
								<th>Seller</th>
								{!hideRestrictedFields && (
									<>
										<th>Foreman</th>
										<th>Foreman Phone</th>
										<th>Relocated</th>
										<th>Subplant</th>
									</>
								)}
								<th>Time</th>
								<th>Job Address</th>
								<th>Load YD3</th>
								<th>Target YD3</th>
								<th>Rate (CY/HR)</th>
								{!hideRestrictedFields && (
									<>
										<th>On Time</th>
										<th>Dest. Time</th>
										<th>Dest. Milles</th>
									</>
								)}
								<th style={{ width: "4%" }}>Mix Design</th>
								<th>Slump</th>
								<th>Fiber YD3</th>
								<th>COGS</th>
								<th>Sold Price</th>
								<th>Gross</th>
								<th>Approved Price</th>
								<th>QB Price</th>
								{!hideRestrictedFields && (
									<>
										<th>Factored Invoice</th>
										<th>Minimum Price</th>
										<th>Maximum Price</th>
									</>
								)}
								<th>Pour/Type</th>
								<th>Status</th>
								<th>Scheduled Date</th>
								{jobHold && <th>Hold</th>}
								<th>Check In</th>
								<th>Ice Surcharge</th>
								<th>Light Surcharge</th>
								<th>Pour</th>
								<th>QA/QC</th>
								<th>Etickets</th>
								{/* <th>Project</th> */}
								{isPriorityActive && <th>Priority</th>}
								<th style={{ width: "6%" }}>Comments</th>
								<th>Franchise</th>
								<th>Edit</th>
							</tr>
						</thead>
						<tbody>{jobsForStatus2("Active")}</tbody>
					</table>
				</div>
			</div>
		);
	};
	const RenderPouredJobs = () => {
		return (
			<div style={{ fontSize: "13px" }}>
				<h3>Poured Jobs</h3>
				<h5>Total LoadYD3: {pouredLoadYD3}</h5>
				<div className="table-responsive overflow-auto">
					<table className="table">
						<thead>
							<tr>
								<th>Confirm</th>
								<th>JobID</th>
								<th style={{ width: "10%" }}>Customer</th>
								<th>Customer PO#</th>
								<th>Seller</th>
								{!hideRestrictedFields && (
									<>
										<th>Foreman</th>
										<th>Foreman Phone</th>
										<th>Relocated</th>
										<th>Subplant</th>
									</>
								)}
								<th>Time</th>
								<th>Job Address</th>
								<th>Load YD3</th>
								<th>Target YD3</th>
								<th>Rate (CY/HR)</th>
								{!hideRestrictedFields && (
									<>
										<th>On Time</th>
										<th>Dest. Time</th>
										<th>Dest. Milles</th>
									</>
								)}
								<th style={{ width: "4%" }}>Mix Design</th>
								<th>Slump</th>
								<th>Fiber YD3</th>
								<th>COGS</th>
								<th>Sold Price</th>
								<th>Gross</th>
								<th>Approved Price</th>
								<th>QB Price</th>
								{!hideRestrictedFields && (
									<>
										<th>Factored Invoice</th>
										<th>Minimum Price</th>
										<th>Maximum Price</th>
									</>
								)}
								<th>Pour/Type</th>
								<th>Status</th>
								<th>Scheduled Date</th>
								{jobHold && <th>Hold</th>}
								<th>Check In</th>
								<th>Ice Surcharge</th>
								<th>Light Surcharge</th>
								<th>Pour</th>
								<th>QA/QC</th>
								<th>Etickets</th>
								{/* <th>Project</th> */}
								{isPriorityActive && <th>Priority</th>}
								<th style={{ width: "6%" }}>Comments</th>
								<th>Franchise</th>
								<th>Edit</th>
							</tr>
						</thead>
						<tbody>{jobsForStatus2("ok")}</tbody>
					</table>
				</div>
			</div>
		);
	};

	const RenderRegularJobs = () => {
		return (
			<div style={{ fontSize: "13px" }}>
				<h3>Regular Jobs</h3>
				<h5>Total TargetYD3: {readyTargetYD3}</h5>
				<div className="table-responsive overflow-auto">
					<table className="table">
						<thead>
							<tr>
								<th>Confirm</th>
								<th>JobID</th>
								<th style={{ width: "10%" }}>Customer</th>
								<th>Customer PO#</th>
								<th>Seller</th>
								{!hideRestrictedFields && (
									<>
										<th>Foreman</th>
										<th>Foreman Phone</th>
										<th>Relocated</th>
										<th>Subplant</th>
									</>
								)}
								<th>Time</th>
								<th>Job Address</th>
								<th>Load YD3</th>
								<th>Target YD3</th>
								<th>Rate (CY/HR)</th>
								{!hideRestrictedFields && (
									<>
										<th>On Time</th>
										<th>Dest. Time</th>
										<th>Dest. Milles</th>
									</>
								)}
								<th style={{ width: "4%" }}>Mix Design</th>
								<th>Slump</th>
								<th>Fiber YD3</th>
								<th>COGS</th>
								<th>Sold Price</th>
								<th>Gross</th>
								<th>Approved Price</th>
								<th>QB Price</th>
								{!hideRestrictedFields && (
									<>
										<th>Factored Invoice</th>
										<th>Minimum Price</th>
										<th>Maximum Price</th>
									</>
								)}
								<th>Pour/Type</th>
								<th>Status</th>
								<th>Scheduled Date</th>
								{jobHold && <th>Hold</th>}
								<th>Check In</th>
								<th>Ice Surcharge</th>
								<th>Light Surcharge</th>
								<th>Pour</th>
								<th>QA/QC</th>
								<th>Etickets</th>
								{/* <th>Project</th> */}
								{isPriorityActive && <th>Priority</th>}
								<th style={{ width: "6%" }}>Comments</th>
								<th>Franchise</th>
								<th>Edit</th>
							</tr>
						</thead>
						<tbody>
							{jobsForStatus("Operations done (AR)")}
							{jobsForStatus("Ready to Load")}
							{jobsForStatus("Confirm")}
							{jobsForStatus("Waiting Inspection")}
							{jobsForStatus("New Order")}
							{losJobs()}
						</tbody>
					</table>
				</div>
			</div>
		);
	};

	const onSuccessApprovedPrice = () => {
		handleShowModalApprovedPrice();
		setRefresh((prev) => !prev);
	};

	return (
		<Layout title="Daily Appointment" description="Job list">
			{loading ? renderLoading() : renderJobs()}
			<Modal
				show={showModal}
				animation={false}
				onHide={handleShowModal}
				dialogClassName="modal-position"
			>
				<Modal.Header closeButton>
					<Modal.Title>Yards Per Seller</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<JobsSellerClassification
						today={`${date.year()}-${date.month() + 1}-${date.date()}`}
						plant={plant}
					/>
				</Modal.Body>
			</Modal>
			<ModalAntd
				centered
				title={`Approved Price by Status`}
				open={showModalApprovedPrice}
				onCancel={handleShowModalApprovedPrice}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
			>
				<ApprovedPriceByStatus
					today={`${date.year()}-${date.month() + 1}-${date.date()}`}
					plant={plant}
					subplant={subplant}
					onSuccess={onSuccessApprovedPrice}
				/>
			</ModalAntd>
			<ModalAntd
				centered
				title={`Download Daily By Job Status`}
				open={showModalDownloadDaily}
				onCancel={handleShowModalDownloadDaily}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={"90%"}
			>
				<DownloadDailyByJobStatus
					today={`${date.year()}-${date.month() + 1}-${date.date()}`}
					plant={plant}
					subplant={subplant}
					onSuccess={onSuccessApprovedPrice}
				/>
			</ModalAntd>
		</Layout>
	);
};

export default connect()(DAppointment);
